import lms from '@/http/lms'
export default {
  namespaced: true,
  actions: {
    async createOutput({}, output) {
      const response = await lms.post('/outputs', output)
      return response
    },
    async createManyOutputs({}, outputs) {
      try {
        const response = await lms.post('/outputs/batch', outputs)
        return response
      } catch (err) {
        console.error(err)
      }
    },
    async deleteOutput({}, output) {
      try {
        const response = await lms.delete(`outputs/knowledge/value/${output.outputValue}`)
        return response
      } catch (err) {
        console.error(err)
      }
    }
  }
}
